<template>
  <div class="featured-dorms__list dorm-card__list user__list-wrp">
    <container>
      <div class="user__list-offer">

        <!--//components-->
        <MessageDetail/>
        <!--//components-->

      </div>
    </container>
  </div>
</template>

<script>
import SubpageNav from '@/components/SubpageNav'
import MessageDetail from '@/components/MessageDetail'

export default {
  name: 'DormUserMessageDetail',
  components: {
    SubpageNav, MessageDetail
  },
  data () {
    return {
      links: [
        {
          id: 0,
          title: 'İstatistikler',
          to: '/yurtlar-istatistik'
        },
        {
          id: 1,
          title: 'Bilgilerim',
          to: '/yurt-hesap-bilgileri'
        },
        {
          id: 2,
          title: 'Rezervasyonlar',
          to: '/kullanici-teklifler'
        },
        {
          id: 3,
          title: 'Mesajlar',
          to: '/mesaj-liste'
        },
        {
          id: 4,
          title: 'Yurtlarım',
          to: '/yurt-sube'
        },
        {
          id: 5,
          title: 'İlanlarım',
          to: '/kullanici-favoriler'
        },
        {
          id: 6,
          title: 'Yorumlar',
          to: '/yurtlar-yorumlar'
        }
      ]
    }
  }
}
</script>

<style lang="scss">

</style>
